import React from "react";
import {
  Grid,
  TextField,
  IconButton,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";

export default function FeatureSectionEditor({
  section,
  onChange,
  ChangeContent,
  title,
}) {
  const features = section.features || [];

  const updateFeature = (idx, key, value) => {
    const newList = [...features];
    newList[idx][key] = value;
    onChange(newList);
  };

  const addFeature = () =>
    onChange([...features, { title: "", description: "", icon: "" }]);
  const removeFeature = (idx) => onChange(features.filter((_, i) => i !== idx));

  return (
    <Box>
      <Typography variant="h6">{title}</Typography>
      <TextField
        fullWidth
        multiline
        label="Description"
        value={section.content?.body || ""}
        onChange={(e) => ChangeContent(e.target.value)}
        sx={{ mb: 2 }}
      />
      {features.map((f, i) => (
        <Grid container spacing={2} alignItems="center" key={i} sx={{ mb: 2 }}>
          <Grid item xs={3}>
            <TextField
              label="Title"
              fullWidth
              value={f.title}
              onChange={(e) => updateFeature(i, "title", e.target.value)}
            />
          </Grid>
          <Grid item xs={7}>
            <TextField
              label="Description"
              fullWidth
              multiline
              value={f.description}
              onChange={(e) => updateFeature(i, "description", e.target.value)}
            />
          </Grid>
          <Grid item xs={1}>
            {/* placeholder for icon picker */}
          </Grid>
          <Grid item xs={1}>
            <IconButton onClick={() => removeFeature(i)}>
              <Delete />
            </IconButton>
          </Grid>
        </Grid>
      ))}
      <Button startIcon={<Add />} onClick={addFeature}>
        Add Feature
      </Button>
    </Box>
  );
}
